<template>
  <div>
    <div v-if="sections && sections.length">
      <div class="ui top attached tabular menu" ref="tabs">
        <a
          class="item"
          :data-tab="'t_' + section.uuid"
          v-for="(section, secidx) in sections"
          :key="secidx"
          >{{ section.name }}</a
        >
      </div>
      <div
        class="ui bottom attached tab segment"
        :data-tab="'t_' + section.uuid"
        v-for="(section, secidx) in sections"
        :key="secidx"
      >
        <!-- <pre>{{ section }}</pre> -->
        <h2 class="ui header">
          <i class="graduation icon"></i>
          <div class="content">
            {{ section.usr_user.name }}
            <div class="sub header">{{ $t("section professor") }}</div>
          </div>
        </h2>
        <table class="ui very compact stiped celled table">
          <thead>
            <tr>
              <th>{{ $t("student id card") }}</th>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("career") }}</th>
              <th>{{ $t("branch") }}</th>
              <th>{{ $t("status") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in section.setup.students" :key="idx">
              <td>{{ item.std_student.student_id_card }}</td>
              <td>{{ item.std_student.name }}</td>
              <td>{{ item.std_career.name }}</td>
              <td>{{ item.std_branch.name }}</td>
              <td
                v-html="isExisting(section, item.std_student.student_id)"
              ></td>
            </tr>
          </tbody>
        </table>
        <!-- <pre>{{ section }}</pre> -->
      </div>
      <!-- <pre>{{ sections }}</pre> -->
    </div>
    <div v-else>
      <div class="ui error message">
        <div class="content">
          <div class="header">
            {{ $t("alert") }}
          </div>
          <p>{{ $t("no sections created yet") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CourseSection from "./Section";
// import { local_api, error_toast } from "@/utils";

export default {
  name: "CourseAssignationRevisionCourse",
  // components: { CourseSection },
  props: {
    course: Object,
    season: Object,
  },
  data() {
    return {
      sections: [],
    };
  },
  computed: {
    // sections() {
    //   let vm = this;
    //   // if (vm.season && vm.season.crs_assignation_sections) {
    //   // console.log("SDF");
    //   if (vm.course && vm.course.sections) {
    //     // return vm.season.crs_assignation_sections
    //     return vm.course.sections.filter((s) => {
    //       return String(s.course_id) == String(vm.course.course_id);
    //     });
    //     // .map((s) => {
    //     //   s.setup = JSON.parse(s.setup);
    //     //   return s;
    //     // });
    //   } else {
    //     return [];
    //   }
    // },
  },
  mounted() {},
  methods: {
    isExisting(section, student_id) {
      let vm = this;
      if (section.crs_assignation_students) {
        let trgt = section.crs_assignation_students.find((s) => {
          return s.student_id == student_id;
        });
        if (trgt) {
          return `<i class="green check icon"></i> ${vm.$t("assigned")}`;
        } else {
          return `<i class="yellow exclamation triangle icon"></i> ${vm.$t(
            "unassigned",
          )}`;
        }
      } else {
        return "?";
      }
    },
    set_sections(sections) {
      let vm = this;
      vm.sections = sections;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.tabs)
          .find(".item")
          .tab();
      }, 500);
    },
  },
  watch: {},
};
</script>
